import { render } from "./Books.vue?vue&type=template&id=584755f7&scoped=true"
import script from "./Books.vue?vue&type=script&lang=js"
export * from "./Books.vue?vue&type=script&lang=js"

import "./Books.vue?vue&type=style&index=0&id=584755f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584755f7"]])

export default __exports__